import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { EudrAnmalanDto } from "../model/EudrAnmalanDto";
import { EudrAnmalanResponseDTO } from "../model/EudrAnmalanResponseDTO";

@Injectable({
    providedIn: "root"
})
export class EudrService {
    private readonly apiClientService = inject(ApiClientService);

    getAll(arbetsorderGuid: string): Observable<EudrAnmalanDto[]> {
        return this.apiClientService.get(`eudr/${arbetsorderGuid}`);
    }

    submit(arbetsorderGuid: string): Observable<EudrAnmalanResponseDTO> {
        return this.apiClientService.post(`eudr/${arbetsorderGuid}`, {

        });
    }

    amend(arbetsorderGuid: string): Observable<EudrAnmalanResponseDTO> {
        return this.apiClientService.put(`eudr/${arbetsorderGuid}`, {

        });
    }

    remove(arbetsorderGuid: string): Observable<EudrAnmalanResponseDTO> {
        return this.apiClientService.delete(`eudr/${arbetsorderGuid}`);
    }

    getStatementByIdentifier(referenceNumber: string, verificationNumber: string ): Observable<any> {
        return this.apiClientService.get(`eudr/${referenceNumber}/${verificationNumber}`);
    }
}
